import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import { getSecret } from "../../helper/utils";

const SECRET_KEY = getSecret();

// 🔹 Function to Decrypt Game Settings from Local Storage
const getDecryptedGameSettings = () => {
    const encryptedData = localStorage.getItem("gameSettings");
    if (!encryptedData) return null;

    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        console.error("Error decrypting game settings:", error);
        return null;
    }
};

// 🔹 Redux Slice
const gameSettingsSlice = createSlice({
    name: "gameSettings",
    initialState: {
        data: getDecryptedGameSettings(), // Initialize from storage
        loading: false,
        error: null,
    },
    reducers: {
        // Set Game Settings (Used when data comes from Socket)
        setGameSettings: (state, action) => {
            state.data = action.payload;
            const encryptedData = CryptoJS.AES.encrypt(
                JSON.stringify(action.payload),
                SECRET_KEY
            ).toString();
            localStorage.setItem("gameSettings", encryptedData);
        },
        clearGameSettings: (state) => {
            state.data = null;
            localStorage.removeItem("gameSettings");
        },
    },
});

export const getGameSettings = (state) => state.gameSettings.data;
export const { setGameSettings, clearGameSettings } = gameSettingsSlice.actions;
export default gameSettingsSlice.reducer;
